import { every, flatMap, includes } from "lodash";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useTrackEvent } from "../../../../common/api/useTrackEvent";
import { Modal, Typography } from "../../../../common/components";
import { ANALYTICS_EVENTS } from "../../../../common/constants/analytics.constants";
import { FLOW_TYPES, STEPS } from "../../constants";
import { useSetUpSpacesStore } from "../../store";
import { DialogStepper } from "../DialogStepper";
import { SpacePurposesTable } from "../SpacePurposesTable";

const AssignSpaces = () => {
    const { t } = useTranslation(["common", "setUpSpaces", "spaces"]);

    const { toggleVisibility, setStep, spaces, spacePurposes, flowType } =
        useSetUpSpacesStore();
    const { trackEvent } = useTrackEvent();

    const areAllSpaceAssigned = useCallback(() => {
        const allSpaces = flatMap(spacePurposes, "spaces");
        return every(spaces, (space) => includes(allSpaces, space));
    }, [spacePurposes, spaces]);

    const getTitle = () => {
        if (flowType === FLOW_TYPES.ADD_SPACES) {
            return t("spaces:addNewSpaces");
        }
        return t("setUpSpaces:spacePurposes.title");
    };

    const handleClickBack = () => setStep(STEPS.ADD_SPACE_PURPOSES);

    const handleClickNext = () => {
        if (!areAllSpaceAssigned()) {
            return;
        }

        setStep(STEPS.SUMMARY);
        trackEvent(ANALYTICS_EVENTS.ALLOCATE_SPACES_TO_SPACE_PURPOSE);
    };

    return (
        <Modal
            title={getTitle()}
            isOpen
            hasCancelButton
            hasOkButton
            onClickCancel={handleClickBack}
            onClickClose={toggleVisibility}
            cancelText={t("common:back") || ""}
            okText={t("common:next") || ""}
            onClickOk={handleClickNext}
            isOkButtonDisabled={!areAllSpaceAssigned()}
            className="max-w-full"
        >
            <div className="flex flex-col gap-4 pb-4">
                <DialogStepper activeStep={STEPS.ASSIGN_SPACES} />
                <h3 className="text-lg">
                    {t("setUpSpaces:assignSpaces.title")}
                </h3>
                <Typography className="font-light">
                    {t("setUpSpaces:assignSpaces.description")}
                </Typography>
            </div>

            <SpacePurposesTable />
        </Modal>
    );
};

export default AssignSpaces;
